import { FetchHttpRequest } from './core/FetchHttpRequest';
import { BranchService } from './services/BranchService';
import { CommitService } from './services/CommitService';
import { DiffService } from './services/DiffService';
import { FileService } from './services/FileService';
import { HealthService } from './services/HealthService';
import { RemoteService } from './services/RemoteService';
import { ThemeComponentsService } from './services/ThemeComponentsService';
export class Client {
    constructor(config, interceptor) {
        var _a, _b, _c, _d;
        Object.defineProperty(this, "branch", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "commit", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "diff", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "file", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "health", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "remote", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "themeComponents", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "request", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "interceptor", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.interceptor = interceptor;
        this.request = new FetchHttpRequest({
            BASE: (_a = config === null || config === void 0 ? void 0 : config.BASE) !== null && _a !== void 0 ? _a : 'https://app.blueharvest.cloud/syncer',
            VERSION: (_b = config === null || config === void 0 ? void 0 : config.VERSION) !== null && _b !== void 0 ? _b : '1.0.1',
            WITH_CREDENTIALS: (_c = config === null || config === void 0 ? void 0 : config.WITH_CREDENTIALS) !== null && _c !== void 0 ? _c : false,
            CREDENTIALS: (_d = config === null || config === void 0 ? void 0 : config.CREDENTIALS) !== null && _d !== void 0 ? _d : 'include',
            TOKEN: config === null || config === void 0 ? void 0 : config.TOKEN,
            USERNAME: config === null || config === void 0 ? void 0 : config.USERNAME,
            PASSWORD: config === null || config === void 0 ? void 0 : config.PASSWORD,
            HEADERS: config === null || config === void 0 ? void 0 : config.HEADERS,
            ENCODE_PATH: config === null || config === void 0 ? void 0 : config.ENCODE_PATH,
        }, this.interceptor);
        this.branch = new BranchService(this.request);
        this.commit = new CommitService(this.request);
        this.diff = new DiffService(this.request);
        this.file = new FileService(this.request);
        this.health = new HealthService(this.request);
        this.remote = new RemoteService(this.request);
        this.themeComponents = new ThemeComponentsService(this.request);
    }
}
//# sourceMappingURL=Client.js.map